/* eslint-disable func-names, max-len */
if ($('.automotive').length > 0) {
  const $toggleDetails = $('.js-toggle-details');
  const accordionToggleClass = 'toggle-details--open';

  $toggleDetails.on('click tap', function () {
    $(this).toggleClass(accordionToggleClass);
  });

  // when page scrolls add and remove active section class from sidenav in correspondance to where the page scroll is
  $(window).on('scroll', () => {
    $('.sections > div').each(function () {
      const $this = $(this);

      const sectionpos = $this.offset().top;

      const sectionInd = $this.index();

      const yScrollPosi = window.pageYOffset + $('header').height();

      if (yScrollPosi > sectionpos) {
        $(`.side-nav ul li:eq(${sectionInd})`).addClass('active');
        $(`.side-nav ul li:gt(${sectionInd})`).removeClass('active');
        $(`.side-nav ul li:lt(${sectionInd})`).removeClass('active');
      }
    });
  });

  $('.automotive.side-nav ul li i').click(function () {
    if ($(window).innerWidth() > 767) {
      const inOfClick = $(this).parent().index();
      const offsetTop = $(`.sections > div:eq(${inOfClick})`).offset().top;
      const headerHeight = $('header').height();

      // scroll to the corresponding brand div position
      $('html, body').animate({
        scrollTop: offsetTop - (headerHeight + 1),
      }, 1300);
    }
  });

  if ($('.my-ryobi-projects').length === 0) {
    $('.features-item').hide();
  }

  // if ($(".product-videos").length === 0) {
  //    $(".video-item").hide();
  // }

  if ($('.side-nav li:visible').length === 1) {
    $('.side-nav').hide();
  }

  if ($('.automotive__footer-nav li:visible').length === 1) {
    $('.automotive__footer-nav nav').hide();
  }
}
